import React from 'react';
import { Container, Typography, Grid, Box, Card, CardContent } from '@mui/material';
import BookingForm from '../components/BookingForm';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import HandymanIcon from '@mui/icons-material/Handyman';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import BuildIcon from '@mui/icons-material/Build';

const features = [
  {
    icon: EventAvailableIcon,
    title: 'Easy Scheduling',
    description: 'Book your repair appointment at your convenience'
  },
  {
    icon: HandymanIcon,
    title: 'Expert Service',
    description: 'Professional technicians for all device types'
  },
  {
    icon: SupportAgentIcon,
    title: '24/7 Support',
    description: 'Customer service available for appointment assistance'
  },
  {
    icon: BuildIcon,
    title: 'Quality Repairs',
    description: 'Guaranteed satisfaction with our repair services'
  }
];

function Booking() {
  return (
    <Box sx={{ bgcolor: 'background.default', py: { xs: 4, sm: 6, md: 8 } }}>
      <Container maxWidth="lg">
        <Typography 
          variant="h2" 
          align="center" 
          gutterBottom
          className="gradient-text"
          sx={{ 
            mb: { xs: 3, sm: 4, md: 6 },
            fontSize: { xs: '2.5rem', sm: '3rem', md: '3.75rem' }
          }}
        >
          AkdmeShop Booking Services
        </Typography>
        <Typography 
          variant="h5" 
          align="center" 
          color="text.secondary" 
          sx={{ 
            mb: { xs: 4, sm: 6, md: 8 },
            maxWidth: 800, 
            mx: 'auto',
            fontSize: { xs: '1.1rem', sm: '1.25rem' }
          }}
        >
          Schedule a repair appointment with our expert technicians for any device
        </Typography>

        <Grid container spacing={4}>
          {/* Feature Cards */}
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card 
                className="glass-effect"
                sx={{ 
                  height: '100%',
                  background: 'linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(37, 99, 235, 0.2) 100%)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '15px',
                  boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.1)'
                  }
                }}
              >
                <CardContent sx={{ p: 3, textAlign: 'center' }}>
                  {React.createElement(feature.icon, { 
                    sx: { 
                      fontSize: 40,
                      color: 'primary.main',
                      mb: 2
                    } 
                  })}
                  <Typography variant="h6" gutterBottom>
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}

          {/* Booking Form */}
          <Grid item xs={12}>
            <Box
              sx={{ 
                width: '100%',
                background: 'linear-gradient(135deg, rgba(37, 99, 235, 0.05) 0%, rgba(37, 99, 235, 0.1) 100%)',
                backdropFilter: 'blur(10px)',
                borderRadius: '15px',
                boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                mt: { xs: 2, sm: 4 }
              }}
            >
              <BookingForm />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Booking;
